import React from "react";
import "style/Footer.scss";

import SliderBoxItems from "components/SliderBoxItems";

interface Props {
  items: {
    ID: number;
    NAME: string;
    IMAGE: string;
    TITLE: string;
    TEXT: string;
  }[];
}

interface State {}

class SliderBox extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  render() {
    const { items } = this.props;
    return (
      <>
        {items &&
          items.map((value) => (
            <SliderBoxItems
              key={value.ID}
              id={value.ID}
              name={value.NAME}
              image={value.IMAGE}
              title={value.TITLE}
              text={value.TEXT}
            />
          ))}
      </>
    );
  }
}

export default SliderBox;
